import React from "react";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';

import Container from "./container"
import Buttons from "./buttons"

const Show = styled.section`
    background-color: white;
`
const Simple = styled.div`
    display: ${isMobile ? "block":"flex"};
    justify-content: center;
    margin: 0px auto;

    > div {
        flex-basis: 33%;
    }
    > div:nth-child(1) {
        padding: 25px;
        background-color: #F0CD4E;
        text-align: center;
        font-size: 50px;
        font-weight: bold;
        color: black;
        text-transform: uppercase;
        display: flex;
        align-items: center;
    }
    > div:nth-child(2) {
        background-color: black;

        img {
            width: 100%;
        }

        > div {
            text-align: center;
            font-size: 22px;
            padding: 5px;
        }        
    }
    > div:nth-child(3) {
        padding-left: 15px;
        font-size: 18px;
        line-height: 1.5em;
        color: black;
    }
`

function ShowTemplate({show}) {
  return (
    <Show>    
        <Container>
            <Simple>
                <div>
                    <div>Special Film Screening</div>
                </div>
                <div>
                    <img src={show.poster} alt={show.title + " Poster"} width={200} />
                    <div>
                        {show.dateFormatted}
                    </div>
                    <div>
                        {show.length}
                    </div>
                </div>
                <div>
                    {show.description}

                    <Buttons show={show} more tickets />
                </div>
            </Simple>
        </Container> 
    </Show>
  );
}

export default ShowTemplate;